export const chartLocale = () => {
  let candidate='en-US';
  try { candidate=localStorage.getItem('trader_language')==='tr'?'tr-TR':'en-US'; } catch { /* Storage can be unavailable. */ }
  try {return Intl.getCanonicalLocales(candidate)[0]||'en-US';}
  catch {return 'en-US';}
};